var alertHistoryList = {
	caption: "Cronologia degli Avvisi",
	noResultsMessage: "Nessun risultato trovato",
	actions: "Azioni",
	alert: {
		date: "Alert date",
		time: "Time",
		trigger: "Valore alert",
		limitType: "Limit type",
		limitAbove: "Ultimo: superiore",
		limitBelow: "Ultimo: inferiore"
	},
	security: {
		name: "Nome",
		isin: "ISIN",
		lastPrice: "Ultimo",
		lastPriceDateTime: "Ultima data",
		assetClass: "Asset class",
		exchange: "Mercato"
	}
};
var it = {
	alertHistoryList: alertHistoryList
};

export { alertHistoryList, it as default };
